import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IAppState } from '../state/app.state';
import { AgentService } from '../../Services/Agent/agent.service';
import { Injectable } from '@angular/core';
import { map, switchMap, catchError, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { GetAllAgents, EAgentActions, GetAddAgentSuccess, GetAllAgentsSuccess, GetAllAgentsError, AddAgent, GetAddAgentError,ImportAgent, GetImportAgentError,GetImportAgentSuccess, EditAgent, GetEditAgentSuccess, GetEditAgentError, DownloadFile, AgentInactivestatus, Agentactivestatus, GetAgentsBystatusId, DownloadFileByUrl } from '../actions/agent.action';

@Injectable()
export class AgentEffects {

    getallagents$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllAgents>(EAgentActions.GetAllAgents),
        map(action => action.payload),
        switchMap((payload : any) => {
            return this.agentService.getAllAgent(payload).pipe(
                map((result: any) => {
                    return new GetAllAgentsSuccess(result);
                }),
                catchError((err) => of(new GetAllAgentsError(err)))
            );
        })));

    addagents$ = createEffect(() => this.actions$.pipe(
        ofType<AddAgent>(EAgentActions.AddAgent),
        map(action => action.payload),
        switchMap((payload : any) => {
            return this.agentService.addAgent(payload).pipe(
                map((result: any) => {
                    return new GetAddAgentSuccess(result);
                }),
                catchError((err) => of(new GetAddAgentError(err)))
            );
        })));

    importagents$ = createEffect(() => this.actions$.pipe(
        ofType<ImportAgent>(EAgentActions.ImportAgent),
        map(action => action.payload),
        switchMap((payload : any) => {
            return this.agentService.importAgent(payload).pipe(
                map((result: any) => {
                    return new GetImportAgentSuccess(result);
                }),
                catchError((err) => of(new GetImportAgentError(err)))
            );
        })));

    editagents$ = createEffect(() => this.actions$.pipe(
        ofType<EditAgent>(EAgentActions.EditAgent),
        map(action => action),
        switchMap((action) => {
            return this.agentService.editAgent(action.payload, action.param).pipe(
                map((result: any) => {
                    return new GetEditAgentSuccess(result);
                }),
                catchError((err) => of(new GetEditAgentError(err)))
            );
        })));


        downloadFile$ = createEffect(() => this.actions$.pipe(
            ofType<DownloadFile>(EAgentActions.DownloadFile),
            map(action => action.payload),
            mergeMap((payload : any) => this.agentService.downloadFile(payload)
            .pipe(map((result: any) => ({ type: '[Agents] Get Download File Success', payload: result, from: 'DownloadFile' })),
              catchError((err) => of({ type: '[] Get Download File Error', payload:err, from: 'DownloadFile' }))
            )
          )
        ));

        downloadFileByUrl$ = createEffect(() => this.actions$.pipe(
            ofType<DownloadFileByUrl>(EAgentActions.DownloadFileByUrl),
            map((action) => action.payload),
            mergeMap((payload: any) =>
            this.agentService.downloadFileByUrl(payload).pipe(
                map((result: any) => ({
                    type: EAgentActions.GetDownloadFileSuccess,
                    payload: result,
                    from: 'DownloadFileByUrl',
                })),
                catchError((err) =>
                of({
                    type: EAgentActions.GetDownloadFileError,
                    payload: err,
                    from: 'DownloadFileByUrl',
                })
                )
            )
            )
        ));

        inactiveagents$ = createEffect(() => this.actions$.pipe(
            ofType<AgentInactivestatus>(EAgentActions.AgentInactivestatus),
            map(action => action),
            mergeMap((action) => this.agentService.inactiveagents(action.payload, action.param)
            .pipe(map((result: any) => ({ type: '[Agents] Get Agent InActive Success', payload: result, from: 'Inactiveagents' })),
              catchError((err) => of({ type: '[Agents] Get Agent InActive Error', payload:err, from: 'Inactiveagents' }))
            )
          )
        ));

        activeagents$ = createEffect(() => this.actions$.pipe(
            ofType<Agentactivestatus>(EAgentActions.Agentactivestatus),
            map(action => action),
            mergeMap((action) => this.agentService.activateagents(action.payload, action.param)
            .pipe(map((result: any) => ({ type: '[Agents] Get Agent Active Success', payload: result, from: 'activeagents' })),
              catchError((err) => of({ type: '[Agents] Get Agent Active Error', payload:err, from: 'activeagents' }))
            )
          )
        ));

        getAgentsByStatusId$ = createEffect(() => this.actions$.pipe(
            ofType<GetAgentsBystatusId>(EAgentActions.GetAgentsBystatusId),
            map(action => action.payload),
            mergeMap((action) => this.agentService.getAgentsByStatusId(action)
            .pipe(map((result: any) => ({ type: '[Agents] Get Agents By statusId Success', payload: result, from: 'getAgentsBystatusId' })),
              catchError((err) => of({ type: '[Agents] Get Agents By statusId Error', payload:err, from: 'getAgentsBystatusId' }))
            )
          )
        ));
        constructor(
            private actions$: Actions,
            private store: Store<IAppState>,
            private agentService: AgentService,

        ) { }

    }
